export default class Display
{
    constructor ()
    {
        Display.instance = this;
        this.mode = "responsive";
        this.minSize = {width:0, height:0};
        this.maxSize = {width:1920, height:1080};
        this.scaleSize = {width:960, height:540};
        this.landscapeRatio = 16 / 9;

    }

    isHybridScale ()
    {
        if (this.mode !== "hybrid")
            return false;

        let windowWidth = window.innerWidth;
        let windowHeight= window.innerHeight;

        return (
            windowWidth < this.minSize.width ||
            windowWidth > this.maxSize.width ||
            windowHeight < this.minSize.height ||
            windowHeight > this.maxSize.height
        );


    }

    static getScreenSize ()
    {

        let width = window.innerWidth;
        let height = window.innerHeight;

        return {width, height};

    }


    static getCanvasSize ()
    {

        let width = window.innerWidth;
        let height = window.innerHeight;

        return {width, height};

    }

    getOrientation ()
    {
        let ratio = this.getWidth() / this.getHeight();

        if (ratio >= this.landscapeRatio)
            return "landscape";

        return "portrait";
    }


    getWindowOrientation ()
    {
        let ratio = this.getWindowRatio();

        if (ratio >= this.landscapeRatio)
            return "landscape";

        return "portrait";
    }


    getWindowRatio ()
    {
        return  window.innerWidth / window.innerHeight;
    }

    getWidth ()
    {
        let windowWidth = window.innerWidth;
        let windowHeight= window.innerHeight;

        return windowWidth;
        // if (this.mode === "responsive")
        // {
        //     let width =  Math.max(windowWidth, this.minSize.width);
        //
        //     return width;
        // }
        //
        //
        // let strOrientation = this.getWindowOrientation();
        //
        // let ratio = this.getWindowRatio();
        //
        // let width = 0;
        //
        // if (strOrientation === "landscape")
        // {
        //     //width = Math.max(this.scaleSize.width, windowWidth);
        //     width = windowHeight * this.landscapeRatio;
        // }
        // else //portrait
        // {
        //     width = windowWidth;
        // }
        //
        //
        // //console.log("getWidth2 ", width, strOrientation, ratio);
        // return width;
    }

    getHeight ()
    {
        let windowWidth = window.innerWidth;
        let windowHeight= window.innerHeight;

        return windowHeight;

        if (this.mode === "responsive")
        {
            let height = Math.max(windowHeight, this.minSize.height);

            return height;
        }
        else if (this.mode === "hybrid")
        {

            if (!this.isHybridScale())
            {
                //act as responsive
                let height = Math.max(windowHeight, this.minSize.height);

                return height;

            }

        }


        //SCALING MODE

        let strOrientation = this.getWindowOrientation();

        let ratio = this.getWindowRatio();

        let height = 0;

        let width = this.getWidth();

        height = width / this.landscapeRatio;




        //console.log("getHeight2 ", height, strOrientation, ratio, this.scaleSize.height , (windowWidth / this.landscapeRatio), windowWidth, this.landscapeRatio);
        return height;
    }

    setLandscapeRatio (ratio)
    {
        this.landscapeRatio = ratio;
    }

    setMinimumSize (width, height)
    {
        this.minSize = {width, height};
    }

    setMaximumSize (width, height)
    {
        this.maxSize = {width, height};
    }
}

let __display = new Display();